export const CPO_CARS_PAGE_NAME = 'cpo_programs_cars_index';
export const CPO_CARS_PAGE_CATEGORY = 'cpo_programs';

export const PROGRAM_FIELDS_MAP = {
  cpo_milage: 'maxMiles',
  cpo_warranty: 'warranty',
  warrantyFootnote: 'warrantyFootnote',
  cpo_roadside: 'roadsideAssistance',
  cpo_deduct: 'deductible',
  cpo_return: 'returnExchangePolicy',
  returnExchangePolicy: 'returnExchangeFootnote',
  cpo_repair: 'outOfTownRepair',
  cpo_free: 'freeServiceLoan',
  freeServiceLoanFootnote: 'freeServiceLoanFootnote',
  cpo_finance: 'specialFinanceTerms',
  cpo_transfer: 'transferable',
  cpo_carfax: 'carfaxReport',
  cpo_certify: 'dealerCertificationRequired',
  cpo_maintenance: 'maintenance',
};

export const PROGRAM_FIELD_NAME_MAP = {
  cpo_maintenance: 'Service / Maintenance',
  cpo_return: 'Return/Exchange Policy',
  cpo_repair: 'Out of Town Repair/Expense',
  cpo_carfax: 'Vehicle History Report',
  cpo_transfer: 'Transferability',
  cpo_warranty: 'Warranty Terms',
  cpo_certify: 'Dealer Certification Required',
  cpo_milage: 'Maximum Age/Mileage',
  cpo_deduct: 'Deductible',
  cpo_free: 'Free Service Loan',
  cpo_finance: 'Special Finance Terms',
  cpo_roadside: 'Roadside Assistance',
};
